namespace $.$$ {

	export class $shm_ba_chart_timeseries extends $.$shm_ba_chart_timeseries {

		navigation_button_node: HTMLElement | null = null
		navigation_button_handler = ( event: Event )=> {
			const button = ( event as MouseEvent ).button
			if( button !== 3 && button !== 4 ) return
			event.stopPropagation()
		}

		navigation_button_listen() {
			const node = this.Chart().dom_node() as HTMLElement
			if( node === this.navigation_button_node ) return
			this.navigation_button_node?.removeEventListener( 'mousedown', this.navigation_button_handler, true )
			node.addEventListener( 'mousedown', this.navigation_button_handler, true )
			this.navigation_button_node = node
		}

		override destructor() {
			this.navigation_button_node?.removeEventListener( 'mousedown', this.navigation_button_handler, true )
			this.navigation_button_node = null
			super.destructor()
		}

		@ $mol_mem
		plot_left( next?: number ) {
			return next ?? 8
		}

		plot_left_style() {
			return `${ Math.round( this.plot_left() ) }px`
		}

		@ $mol_action
		chart_finished( next?: any ) {
			if( next === undefined ) return null
			this.navigation_button_listen()
			const grid_left = this.Chart().grid_rect()?.x
			const left = grid_left === undefined ? undefined : Math.round( grid_left )
			if( left !== undefined && left !== this.plot_left() ) this.plot_left( left )
			return next
		}

		group_options() {
			return {
				... this.group() === 'minute5' ? { minute5: 'По 5 минут' } : {},
				hour: 'По часам',
				day: 'По дням',
				week: 'По неделям',
				month: 'По месяцам',
				quarter: 'По кварталам',
			}
		}

		option() {
			const rows = this.rows() as readonly ( readonly [ string, number, string, string? ] )[]
			const configured = this.overlay_series() as readonly { title: string; rows: readonly ( number | null )[] }[]
			const overlays = configured.length ? configured : [{ title: this.overlay_title(), rows: this.overlay_rows() as readonly ( number | null )[] }]
			const visible_overlays = overlays.filter( overlay => overlay.rows.some( value => value !== null && Number.isFinite( value ) ) )
			const overlay_visible = visible_overlays.length > 0
			return {
				tooltip: { trigger: 'axis' },
				toolbox: {
					show: false,
					feature: {
						brush: {
							show: false,
						},
					},
				},
				brush: {
					toolbox: [],
					xAxisIndex: 0,
					brushMode: 'single',
					brushType: 'lineX',
					transformable: false,
					throttleType: 'debounce',
					throttleDelay: 200,
				},
				grid: { left: 8, right: 24, top: 24, bottom: 48, containLabel: true },
				xAxis: { type: 'category', data: rows.map( row => row[0] ) },
				yAxis: overlay_visible
					? [
						{ type: 'value' },
						{
							type: 'value',
							// name: 'Wordstat',
							position: 'right',
							splitLine: { show: false },
						},
					]
					: { type: 'value' },
				series: [{
					name: this.title(),
					type: 'bar',
					cursor: 'pointer',
					data: rows.map( row => row[1] ),
				}, ... visible_overlays.map( overlay => ({
					name: overlay.title,
					type: 'line',
					yAxisIndex: 1,
					showSymbol: true,
					symbolSize: 6,
					connectNulls: true,
					data: overlay.rows,
				}))],
			}
		}

		brush_cursor() {
			return {
				brushType: 'lineX',
				brushMode: 'single',
			}
		}

		bar_click( next?: any ) {
			if( next === undefined ) return null
			if( next.event?.event?.button !== undefined && next.event.event.button !== 0 ) return next

			const index = Number( next.dataIndex )
			const row = ( this.rows() as readonly ( readonly [ string, number, string, string? ] )[] )[ index ]
			if( this.group() === 'minute5' && this.rows().length <= 1 ) return next
			const date = row?.[3] || row?.[2]
			if( date ) this.period_pick( date )
			return next
		}

		brush_end( next?: any ) {
			if( next === undefined ) return null

			const rows = this.rows() as readonly ( readonly [ string, number, string, string? ] )[]
			if( rows.length <= 1 ) return next

			const area = this.brush_area( next )
			const range = area?.coordRange ?? area?.range
			if( !Array.isArray( range ) || range.length < 2 ) return next

			const from = this.brush_index( range[0] )
			const to = this.brush_index( range[1] )
			if( from === null || to === null ) return next

			const first = Math.max( 0, Math.min( from, to ) )
			const last = Math.min( rows.length - 1, Math.max( from, to ) )
			if( first > last ) return next

			const start = rows[ first ]?.[3] || rows[ first ]?.[2]
			const finish = rows[ last ]?.[3] || rows[ last ]?.[2]
			if( start && finish ) this.period_range_pick([ start, finish ])
			return next
		}

		brush_area( next: any ) {
			return next.areas?.[0] ?? next.batch?.[0]?.areas?.[0] ?? null
		}

		brush_index( value: unknown ) {
			if( typeof value === 'number' && Number.isFinite( value ) ) return Math.round( value )
			const rows = this.rows() as readonly ( readonly [ string, number, string, string? ] )[]
			const text = String( value )
			const index = rows.findIndex( row => row[0] === text || row[2] === text || row[3] === text )
			return index >= 0 ? index : null
		}

	}

}
